import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import InterpreterModeOutlinedIcon from "@mui/icons-material/InterpreterModeOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import routes from "../../../Utils/routes";
import { useStyles } from "../styles";
import { ListItemButton, ListItemIcon, ListItemText, Box, Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { useState, useEffect } from "react";
import homeactive from "../../../Assets/navicons/active/home.png";
import home from "../../../Assets/navicons/inactive/home.png";
import learn from "../../../Assets/navicons/inactive/learn.png";
import fee from "../../../Assets/navicons/inactive/feepayment.png";
import feeActive from "../../../Assets/navicons/active/fee.png";
import service from "../../../Assets/navicons/inactive/service.png";
import serviceActive from "../../../Assets/navicons/active/service.png";
import exam from "../../../Assets/navicons/inactive/exams.png";
import examActive from "../../../Assets/navicons/active/exams.png";
import EnrolledCourseIcon from "../../../Assets/CourseEnrollment.svg";
import EnrolledCourseActiveIcon from "../../../Assets/CourseEnrollmentActive.svg";

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  name?: string;
  handleClose?: any;
  filterTabs?: string[];
}

const MobileNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick, name, handleClose, filterTabs }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split("/").filter((items: string) => {
    return items && items !== "";
  });
  const [activeTab, setActiveTab] = useState<string>("");

  const handleActiveTabs = (label: string) => {
    if (activeTab === label) {
      setActiveTab("");
    } else {
      setActiveTab(label);
    }
  };

  useEffect(() => {
    if (getFirstPath[0] === "exams") {
      const isChildActive = getFirstPath[1] === "take-exams" || (getFirstPath[0] === "exams" && !getFirstPath[1]);
      if (isChildActive && activeTab !== "exams") {
        setActiveTab("exams");
      }
    } else if (!pathname.includes(activeTab)) {
      setActiveTab("");
    }
  }, [pathname]);

  const sideNavContents: any = [
    {
      icon: (isActive: boolean) => {
        return <img className={classes.navIcons} src={isActive ? homeactive : home} alt="Home" style={{ filter: isActive ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(19%) sepia(99%) saturate(7496%) hue-rotate(220deg) brightness(99%) contrast(105%)" }} />;
      },
      label: "Home",
      link: routes.home,
      name: "home",
    },
    {
      icon: (isActive: boolean) => {
        return <img className={classes.navIcons} src={learn} alt="Learn" style={{ filter: isActive ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(19%) sepia(99%) saturate(7496%) hue-rotate(220deg) brightness(99%) contrast(105%)" }} />;
      },
      label: "Learn",
      link: routes.learn,
      name: "learn",
    },
    {
      icon: (isActive: boolean) => {
        return (
          <ImportContactsIcon
            sx={{ color: isActive ? '#ffffff' : '#3061FF', fontSize: 24 }}
          />
        );
      },
      label: "Program Path",
      link: routes.programPathway,
      name: "program-path",
    },
    {
      icon: (isActive: boolean) => {
        return <Box component={"img"} className={classes.navIcons} src={isActive ? EnrolledCourseActiveIcon : EnrolledCourseIcon} style={{ filter: isActive ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(19%) sepia(99%) saturate(7496%) hue-rotate(220deg) brightness(99%) contrast(105%)" }} />;
      },
      label: "Course Enrollment",
      link: routes.courseEnrollment,
      name: "course%20enrollment",
    },
    {
      icon: (isActive: boolean) => {
        return <img className={classes.navIcons} src={isActive ? feeActive : fee} alt="Fees" style={{ filter: isActive ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(19%) sepia(99%) saturate(7496%) hue-rotate(220deg) brightness(99%) contrast(105%)" }} />;
      },
      label: "Fees",
      link: routes.fees,
      name: "fees",
    },
    {
      icon: (isActive: boolean) => {
        return <img className={classes.navIcons} src={isActive ? examActive : exam} alt="Examination" style={{ filter: isActive ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(19%) sepia(99%) saturate(7496%) hue-rotate(220deg) brightness(99%) contrast(105%)" }} />;
      },
      label: "Examination",
      link: routes.exams,
      name: "exams",
      child: [
        {
          icon: (isActive: boolean) => {
            return (
              <CalendarTodayIcon
                sx={{ color: isActive ? '#ffffff' : '#b2b3b7', fontSize: 24 }}
              />
            );
          },
          label: "My Exams",
          link: routes.exams,
          name: "exams",
        },
        {
          icon: (isActive: boolean) => {
            return (
              <CalendarTodayIcon
                sx={{ color: isActive ? '#ffffff' : '#b2b3b7', fontSize: 24 }}
              />
            );
          },
          label: "Take Exams",
          link: routes.takeExams,
          name: "take-exams",
        },
      ],
    },
    {
      icon: (isActive: boolean) => {
        return <img className={classes.navIcons} src={isActive ? serviceActive : service} alt="Service & Support" style={{ filter: isActive ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(19%) sepia(99%) saturate(7496%) hue-rotate(220deg) brightness(99%) contrast(105%)" }} />;
      },
      label: "Service & Support",
      link: routes.service,
      name: "service%20&%20support",
    },
    {
      icon: (isActive: boolean) => {
        return (
          <DocumentScannerOutlinedIcon
            sx={{ color: isActive ? '#ffffff' : '#3061FF', fontSize: 24 }}
          />
        );
      },
      label: "Terms & Conditions",
      link: routes.termsAndConditions,
      name: "terms-and-conditions",
    },
  ];

  let filteredNav = sideNavContents;
  if (filterTabs && filterTabs.length) {
    filteredNav = sideNavContents.filter((item: any) => filterTabs.includes(item.label));
  }

  const isAnyChildActive = (items: any) => {
    if (!items?.child || items.child.length === 0) return false;
    return items.child.some((child: any) => {
      if (child.name === "exams" && getFirstPath[0] === "exams" && !getFirstPath[1]) {
        return true;
      }
      return getFirstPath[1] === child.name;
    });
  };

  return filteredNav?.map((items: any, index: number) => {
    const decodedFirstPath = getFirstPath[0] ? decodeURIComponent(getFirstPath[0]) : "";
    const decodedItemName = decodeURIComponent(items.name);
    const isNormalActive = getFirstPath[0] === items.name || decodedFirstPath === decodedItemName || 
                     (items.name === "course%20enrollment" && decodedFirstPath === "course enrollment") ||
                     (items.name === "service%20&%20support" && (decodedFirstPath === "service & support" || pathname.includes("service")));
    
    // For items with children, only highlight parent if parent route is active AND no child is active
    const isParentActive = items?.child && items.child.length > 0 
      ? isNormalActive && !isAnyChildActive(items)
      : isNormalActive;
    const isAccordionExpanded = activeTab === items.name;

    // If item has children, render as accordion
    if (items?.child && items.child.length > 0) {
      return (
        <Accordion
          key={index}
          expanded={isAccordionExpanded}
          onChange={() => {
            handleActiveTabs(items.name);
          }}
          className={classes.accordionRoot}
          sx={{ marginTop: index === 0 ? "15px" : "2px", boxShadow: "none" }}
        >
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon sx={{ color: isParentActive ? '#ffffff' : '#b2b3b7' }} />} 
            aria-controls="panel1-content" 
            id="panel1-header" 
            className={classes.accordionSummary}
          >
            <Box component={"div"} className={`${classes.listItemButton} d-flex align-items-center gap-2 ${isParentActive && classes.listItemButtonActive}`} sx={{ width: "100%" }}>
              <ListItemIcon sx={{ minWidth: { xs: "10px", lg: "40px" } }}>{items.icon(isParentActive)}</ListItemIcon>
              <Typography
                component="span"
                className={`${classes.listItemText} ${isParentActive && classes.listItemTextActive}`}
                fontWeight={isParentActive ? "600" : "400"}
                sx={{ ml: 2 }}
              >
                {items.label}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails} sx={{ padding: 0 }}>
            {(items?.child || []).map((childItem: any, childIndex: number) => {
              let isChildActive = false;
              if (childItem.name === "exams" && getFirstPath[0] === "exams" && !getFirstPath[1]) {
                isChildActive = true;
              } else {
                isChildActive = getFirstPath[1] === childItem.name;
              }
              
              const handleChildClick = () => {
                if (typeof handleClose === "function") {
                  handleClose();
                }
                handleListClick(childItem.link, index);
              };

              return (
                <ListItemButton
                  key={childIndex}
                  onClick={handleChildClick}
                  style={{ marginTop: "1px", paddingLeft: "48px" }}
                  className={`${classes.listItemButton} ${isChildActive && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: "10px", lg: "40px" } }}>{childItem.icon(isChildActive)}</ListItemIcon>
                  <ListItemText className={`${classes.listItemText} ${isChildActive && classes.listItemTextActive}`} sx={{ ml: 2 }}>
                    {childItem.label}
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </AccordionDetails>
        </Accordion>
      );
    }

    const handleTabClick = () => {
      if (typeof handleClose === "function") {
        handleClose();
      }
      handleListClick(items.link, index);
    };
    
    return (
      <ListItemButton 
        key={index}
        onClick={handleTabClick} 
        style={{ marginTop: index === 0 ? "15px" : "2px" }} 
        className={`${classes.listItemButton} ${isNormalActive && classes.listItemButtonActive}`}
      >
        <ListItemIcon sx={{ minWidth: { xs: "10px", lg: "40px" } }}>{items.icon(isNormalActive)}</ListItemIcon>
        <ListItemText className={`${classes.listItemText} ${isNormalActive && classes.listItemTextActive}`} sx={{ ml: 2 }}>
          {items.label}
        </ListItemText>
      </ListItemButton>
    );
  });
};

export default MobileNavTabs;
